import { c as _c } from "react/compiler-runtime";
import { IcoEye16, IcoEyeCrossed16 } from '@onefootprint/icons';
import { useState } from 'react';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import IconButton from '../../icon-button';
import FormInput, { type FormInputProps } from './form-input';
export type FormSsn4Props<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
  defaultVisible?: boolean;
} & Omit<FormInputProps<TFieldValues>, 'name' | 'rules' | 'type' | 'autoComplete'>;
export default function FormSsn4(t0) {
  const $ = _c(27);
  let props;
  let rules;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      rules,
      size: t1,
      defaultVisible: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = rules;
    $[3] = t1;
    $[4] = t2;
  } else {
    props = $[1];
    rules = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const size = t1 === undefined ? "default" : t1;
  const defaultVisible = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation("ui");
  const [isVisible, setIsVisible] = useState(defaultVisible);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /^\d{4}$/;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const ssn4Format = t3;
  let t4;
  if ($[6] !== t) {
    t4 = value => {
      if (!value) {
        return true;
      }
      if (!ssn4Format.test(value)) {
        return t("components.form.ssn4.errors.invalid");
      }
      return true;
    };
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== rules || $[9] !== t4) {
    t5 = {
      validate: t4,
      ...rules
    };
    $[8] = rules;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const ssnRules = t5;
  const t6 = isVisible ? "text" : "password";
  const t7 = isVisible ? IcoEyeCrossed16 : IcoEye16;
  const t8 = size === "compact" ? "tiny" : "default";
  let t9;
  if ($[11] !== isVisible || $[12] !== t) {
    t9 = isVisible ? t("components.form.ssn4.aria-label.hide") : t("components.form.ssn4.aria-label.show");
    $[11] = isVisible;
    $[12] = t;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isVisible) {
    t10 = () => setIsVisible(!isVisible);
    $[14] = isVisible;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t11 = <IconButton icon={t7} color="quaternary" size={t8} aria-label={t9} onClick={t10} />;
    $[16] = t10;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== props || $[22] !== size || $[23] !== ssnRules || $[24] !== t11 || $[25] !== t6) {
    t12 = <FormInput {...props} size={size} rules={ssnRules} type={t6} inputMode="numeric" autoComplete="off" mask={mask} placeholder="XXXX" suffixComponent={t11} />;
    $[21] = props;
    $[22] = size;
    $[23] = ssnRules;
    $[24] = t11;
    $[25] = t6;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
const mask = {
  numericOnly: true,
  blocks: [4]
};